import { useMemo } from "react";
import ShareDialog from "@/components/shared/ShareDialog";
import { buildShareMessages } from "@/lib/shareMessages";

/** Share a student's donation page (parent pages, the public student page). */
export default function StudentShareDialog({ url, firstName, schoolName, triggerLabel = "Share", ...trigger }) {
  const messages = useMemo(() => buildShareMessages({ firstName, schoolName, url }), [firstName, schoolName, url]);

  return (
    <ShareDialog
      url={url}
      title={`Share ${firstName}'s page`}
      description="Send it to family and friends who'd like to cheer them on."
      messages={messages}
      emailSubject={`${firstName}'s read-a-thon for ${schoolName}`}
      shareTitle={`${firstName}'s read-a-thon`}
      triggerLabel={triggerLabel}
      {...trigger}
    />
  );
}
